import { render } from "./komoRoot.vue?vue&type=template&id=574ee59d"
import script from "./komoRoot.vue?vue&type=script&lang=js"
export * from "./komoRoot.vue?vue&type=script&lang=js"

import "./komoRoot.vue?vue&type=style&index=0&id=574ee59d&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__